import { createContext } from 'react';

const SubDomainContext = createContext();

export default SubDomainContext;
